<template>
    <div class="border border-silver">
        <div class="px-4 py-2 font-secondary text-lg bg-light">{{ props.label }}</div>
        <div class="p-4 space-y-2" v-if="!props.range">
            <template v-for="(item, index) in props.options">
                <label v-if="index <= 3 || expanded || props.showAllOptionsDefault" class="flex gap-5 cursor-pointer" :class="{'line-through' : item.unavailable, 'cursor-not-allowed' : item.unavailable}" :title="item.unavailable ? $t('Žádné produkty v aktuálním výběru neodpovídají tomuto filtru. Pro zahrnutí této hodnoty do filtru je nutné vyřadit některé stávající filtrované hodnoty.') : ''">
                    <AtomsFormsCheckbox :checked="item.selected" @change="updateFilter(item.urlParameter, item.urlValue, $event, !!props.singleOptionOnly)" :disabled="item.unavailable" /> {{ item.text }}
                </label>
            </template>
            <div v-if="props.options?.length > 4 && !props.showAllOptionsDefault" class="flex gap-5 cursor-pointer" @click="expand">
                <AtomsFormsCheckbox class="invisible" />
                <button class="text-sm text-conversion underline">{{ !expanded ? 'Další možnosti' : 'Skrýt další možnosti' }}</button>
            </div>
        </div>
        <div class="px-4 py-7" v-if="props.range">
            <div class="flex flex-wrap gap-x-2 gap-y-6 justify-between mb-14">
                <div>
                    Od <span class="p-2 ml-2 border border-silver text-sm"><input type="number" class="w-[60px] border-0 text-right" :min="props.minRange" :max="props.maxRange" v-model="props.minValue" @change="updateRange($event, 0)" /> {{ locale.currencySignLocal }}</span>
                </div>
                <div>
                    Do <span class="p-2 ml-2 border border-silver text-sm"><input type="number" class="w-[60px] border-0 text-right" :min="props.minRange" :max="props.maxRange" v-model="props.maxValue" @change="updateRange($event, 1)" /> {{ locale.currencySignLocal }}</span>
                </div>
            </div>
            <div class="px-9">
                <Slider :min="props.minRange" :max="props.maxRange" v-model="selectedRange" :format="useLocale().formatPrice" @update="updateRange($event)" />
            </div>
        </div>
    </div>
</template>
<script setup>

import Slider from '@vueform/slider'

const props = defineProps({
    label: String,
    urlParameter: String,
    range: String,
    minValue: Number,
    maxValue: Number,
    minRange: Number,
    maxRange: Number,
    options: Array,
    showAllOptionsDefault: Boolean,
    singleOptionOnly: Boolean
});

const locale = useLocale().getLocale();

const minValue = ref(props.minValue);
const maxValue = ref(props.maxValue);

const selectedRange = computed(() => {
    return [props.minValue, props.maxValue];
});

const emit = defineEmits(['applyFilter']);

const expanded = ref(false);

const expand = () => expanded.value = !expanded.value;

const updateRange = ($event, index) => {
    if ($event instanceof Array) {
        minValue.value = $event[0];
        maxValue.value = $event[1];
    }
    else if ($event?.target && typeof index === 'number') {
        if (index === 0) {
            minValue.value = parseInt($event.target.value);

            if (minValue.value >= maxValue.value) {
                maxValue.value = minValue.value;
            }
        }
        else if (index === 1) {
            maxValue.value = parseInt($event.target.value);

            if (minValue.value >= maxValue.value) {
                minValue.value = maxValue.value;
            }
        }
    }

    if (minValue.value <= props.minRange && maxValue.value >= props.maxRange) {
        // selected range equals boundaries => remove filter
        updateFilter(null, `${minValue.value}-${maxValue.value}`, false, true);
    }
    else {
        updateFilter(null, `${minValue.value}-${maxValue.value}`, true, true);
    }
}

const updateFilter = (urlParameter, urlValue, add, replaceValue) => emit('applyFilter', urlParameter ?? props.urlParameter, urlValue, !add, replaceValue);

</script>